import React, { useEffect, useState } from "react";
import {
  Button,
  Empty,
  Pagination,
  Card,
  Row,
  Col,
  Space,
  Tag,
  Typography,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  TagsOutlined,
  EnvironmentOutlined,
  AppstoreOutlined,
  SearchOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import "./nujobsmyrecentsearches.scss";
import useNuJobsResumeAddModalStore from "../../../store/nujobsResuneAddModal.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import NuJobsTable from "../nujobsTable";
import useNuJobsStore from "../../../store/nujobs.store";
import { SUPPORTED_JOB_CATEGORY } from "../../../helper/categoryconstants";
import NuJobsJobListingsSearch from "../nujobListingSearch";

const { Text } = Typography;

export default function NUJobsMyRecentSearches(props) {
  const navigate = useNavigate();
  const { nuJobsGetLastSearch,lastSearchReq,getOSAllJds } = useNuJobsStore();
  const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));

  useEffect(() => {
   nuJobsGetLastSearch();
  }, []);

  const titleList = ["Keywords", "Location", "Category", "Filters"];
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }  

  const isValid = (val) => {
    if (val == null || val == undefined || val == "") return false;
    else return true;
  };
  console.log("lastSearchReq", lastSearchReq);
  const resumeData = lastSearchReq?.map((req, idx) => {
    const categoryLabel = SUPPORTED_JOB_CATEGORY.find(
      (item) => item.value === req?.category,
    )?.label;
    return {
      input: isValid(req?.keywords) ? req?.keywords : "Not Given",
      location: isValid(req?.city) ? req?.city : "Any",
      category: isValid(req?.category) ? req?.category : "Not Given",
      filters: "All",
    };
  });

  const resultHandler = () => {
    navigate(`/nujobshome/nujobsSearchResultHandler`);
  };
  const encodeJson = (values) => {
    let encodedJsonValues = {};
    encodedJsonValues.keywords = values.keywords;
    encodedJsonValues.city = values.location;
    encodedJsonValues.category = values.category;
    encodedJsonValues.timestamp = 0;
    encodedJsonValues.postingdate = "All";
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.maxPerPage = 10;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null  
        
        var loggedIn= true
        if(loggedIn){
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
             encodedJsonValues.nujuid= userData.nujuid   
             encodedJsonValues.nujoid= userData.nujoid
             encodedJsonValues.signedin= true
             encodedJsonValues.pendingsync = JSON.parse(
                localStorage.getItem("NuJobsPendingSync") || "[]"
            );                
        }
        return encodedJsonValues
    }

    const searchAgainHandler = () => {
        const jasonValues = encodeJson(lastSearchReq?.[0])
        getOSAllJds(jasonValues,resultHandler)
    };  

  const getFormattedFilters = (req) => {
    const primaryFilters = [];
    const secondaryFilters = [];

    if (!req) return { primaryFilters, secondaryFilters };

    // 1. Primary Filters (Show directly in the card)
    if (req.minexp > 0 || req.maxexp > 0) {
      primaryFilters.push(`Exp: ${req.minexp || 0}-${req.maxexp || 0} yrs`);
    }
    if (req.minctc > 0 || req.maxctc > 0) {
      primaryFilters.push(`CTC: ${req.minctc || 0}-${req.maxctc || 0}L`);
    }
    if (req.workmode) {
      primaryFilters.push(`Mode: ${req.workmode}`);
    }

    // 2. Secondary Filters (Show in Tooltip)
    if (req.noticeperiod?.length > 0)
      secondaryFilters.push(`Notice: ${req.noticeperiod.join(", ")}`);
    if (req.postingdate?.length > 0)
      secondaryFilters.push(`Posted: ${req.postingdate.join(", ")}`);
    if (req.role?.length > 0)
      secondaryFilters.push(`Role: ${req.role.join(", ")}`);
    if (req.roletype?.length > 0)
      secondaryFilters.push(`Role Type: ${req.roletype.join(", ")}`);
    if (req.companytype) secondaryFilters.push(`Company: ${req.companytype}`);
    if (req.diversity) secondaryFilters.push(`Diversity: ${req.diversity}`);
    if (req.jobfor) secondaryFilters.push(`Job For: ${req.jobfor}`);

    return { primaryFilters, secondaryFilters };
  };

  return (
    <div className="nujobsmyrecentsearches-wrapper">
      <div className="flexComponent-title-wrapper">My Previous Searches</div>

      <div className="flexComponent-wrapper">
        <div className="flexComponent-info-wrapper">
          {lastSearchReq && lastSearchReq.length > 0 ? (
            lastSearchReq.map((req, idx) => {
              // --- CLEAN: Just call the function here ---
              const { primaryFilters, secondaryFilters } =
                getFormattedFilters(req);

              return (
                <Card
                  key={idx}
                  className="recent-search-card"
                  style={{ marginBottom: "16px", borderRadius: "8px" }}
                  hoverable
                >
                  <Row gutter={[24, 16]} align="start">
                    {/* Keywords Section */}
                    <Col xs={24} md={5}>
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <Text strong>
                          <TagsOutlined
                            style={{ color: "#1890ff", marginRight: "8px" }}
                          />
                          Keywords
                        </Text>
                        <div>
                          {req?.keywords && req.keywords.length > 0 ? (
                            req.keywords.map((kw, i) => (
                              <Tag color="blue" key={i}>
                                {kw}
                              </Tag>
                            ))
                          ) : (
                            <Text type="secondary">Not Given</Text>
                          )}
                        </div>
                      </Space>
                    </Col>

                    {/* Locations Section */}
                    <Col xs={24} md={4}>
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <Text strong>
                          <EnvironmentOutlined
                            style={{ color: "#52c41a", marginRight: "8px" }}
                          />
                          Locations
                        </Text>
                        <div>
                          {req?.city && req.city.length > 0 ? (
                            req.city.map((loc, i) => (
                              <Tag color="green" key={i}>
                                {loc}
                              </Tag>
                            ))
                          ) : (
                            <Text type="secondary">Any</Text>
                          )}
                        </div>
                      </Space>
                    </Col>

                    {/* Categories Section */}
                    <Col xs={24} md={5}>
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <Text strong>
                          <AppstoreOutlined
                            style={{ color: "#722ed1", marginRight: "8px" }}
                          />
                          Categories
                        </Text>
                        <div>
                          {req?.category && req.category.length > 0 ? (
                            req.category.map((cat, i) => {
                              const categoryLabel =
                                SUPPORTED_JOB_CATEGORY.find(
                                  (item) => item.value === cat,
                                )?.label || cat;
                              return (
                                <Tag color="purple" key={i}>
                                  {categoryLabel}
                                </Tag>
                              );
                            })
                          ) : (
                            <Text type="secondary">Not Given</Text>
                          )}
                        </div>
                      </Space>
                    </Col>

                    {/* Filters Section */}
                    <Col xs={24} md={6}>
                      <Space
                        direction="vertical"
                        size="small"
                        style={{ width: "100%" }}
                      >
                        <Text strong>
                          <FilterOutlined
                            style={{ color: "#fa8c16", marginRight: "8px" }}
                          />
                          Filters
                        </Text>
                        <div>
                          {/* Render Primary Filters */}
                          {primaryFilters.length > 0
                            ? primaryFilters.map((f, i) => (
                                <Tag color="orange" key={i}>
                                  {f}
                                </Tag>
                              ))
                            : secondaryFilters.length === 0 && (
                                <Text type="secondary">None</Text>
                              )}

                          {/* Render Secondary Filters in a Tooltip */}
                          {secondaryFilters.length > 0 && (
                            <Tooltip
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                  }}
                                >
                                  {secondaryFilters.map((sf, i) => (
                                    <span key={i}>• {sf}</span>
                                  ))}
                                </div>
                              }
                            >
                              <Tag
                                color="orange"
                                style={{
                                  cursor: "pointer",
                                  borderStyle: "dashed",
                                }}
                              >
                                +{secondaryFilters.length} more
                              </Tag>
                            </Tooltip>
                          )}
                        </div>
                      </Space>
                    </Col>

                    {/* Action Section */}
                    <Col
                      xs={24}
                      md={4}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={() => searchAgainHandler(req)}
                      >
                        Search Again
                      </Button>
                    </Col>
                  </Row>
                </Card>
              );
            })
          ) : (
            <Empty description="No Previous Search Found" />
          )}
        </div>
      </div>
    </div>
  );
}
